module.exports = __webpack_public_path__ + "static/media/Logo-IMS.4353f975.png";